import { useMemo } from 'react';

import { useRouter } from '~/hooks';
import { getTranslation } from '~/locale';

export function useTranslation() {
  const { businessUnit, language } = useRouter();

  return useMemo(() => ({ ...getTranslation(businessUnit), language }), [businessUnit, language]);
}
